<section id="downloads">
    <shd-headline [headline]="'DOWNLOADS_OVERVIEW_TITLE'"></shd-headline>
    @if (cadIsInFeatures) {
        <div>
            <h3>{{ 'DASHBOARD_KTSCAD_DISPLAYNAME' | translate }}</h3>
            <div class="row my-4">
                <div class="col-12 col-md-4">
                    @for (version of versions; track version) {
                        <shd-download-item [type]="type.ARCHIVE"
                                           (clicked)="downloadFile(downloadType.Kts, version.value)"
                                           [dataTrack]="'dashboard_download_autocad'"
                                           [label]="version.title"></shd-download-item>

                    }
                </div>
            </div>
        </div>
    }
</section>
